import { flatui_proxy_get, getDataFromResponse } from '../../utils';

export async function fetchAuthNeededList() {
  const resp = await flatui_proxy_get('/gui/adom/dvm/device/csf-auth-status');
  return getDataFromResponse(resp);
}
